import { mapGetters } from "vuex";
import { isSmallDevice, adSubdomain, capitalize } from "@/common/functions";
import Velocity from "velocity-animate";
import LayoutSidebar from "@/layouts/LayoutSidebar/LayoutSidebar.vue";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import Heading from "@/components/Synonym/Heading/Heading.vue";
import MultiSortingDropdown from "@/components/Synonym/MultiSortingDropdown/MultiSortingDropdown.vue";
// import AZSortingToggle from "@/components/Synonym/AZSortingToggle/AZSortingToggle.vue";
import DesktopSynonymFilter from "@/components/Synonym/SynonymFilter/DesktopSynonymFilter/DesktopSynonymFilter.vue";
import SingleSynonym from "@/components/Synonym/SingleSynonym/SingleSynonym.vue";
import Advertising from "@/components/Advertising/Advertising.vue";
import SynonymStudy from "@/components/Synonym/SynonymStudy/SynonymStudy.vue";
import AnotherWord from "@/components/AnotherWord/AnotherWord.vue";
import SentencesExamples from "@/components/SentencesExamples/SentencesExamples.vue";
import RelatedArticles from "@/components/RelatedArticles/RelatedArticles.vue";
import MentionedIn from "@/components/MentionedIn/MentionedIn.vue";
import NearSynonyms from "@/components/NearSynonyms/NearSynonyms.vue";
// StarButton was replaced by CopyButton
// import SaveWordPopup from "@/components/SaveWordPopup/SaveWordPopup.vue";
import MobileSynonymFilter from "@/components/Synonym/SynonymFilter/MobileSynonymFilter/MobileSynonymFilter.vue";
import CopyToast from "@/components/CopyToast/CopyToast.vue";

export default {
    components: {
        LayoutSidebar,
        Breadcrumb,
        Heading,
        MultiSortingDropdown,
        // AZSortingToggle
        DesktopSynonymFilter,
        SingleSynonym,
        Advertising,
        SynonymStudy,
        AnotherWord,
        SentencesExamples,
        RelatedArticles,
        MentionedIn,
        NearSynonyms,
        // StarButton was replaced by CopyButton
        // SaveWordPopup,
        MobileSynonymFilter,
        CopyToast
    },
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            layout: LayoutSidebar,
            subdomain: adSubdomain(this.$route.meta.subdomain),
            showMobileAdsInRows: [2, 11],
            mobileReuseAds: [
                "Mobile_Thesaurus_Detail_InContent_Top",
                "Mobile_Thesaurus_Detail_InContent_Middle"
            ],
            bottomToastPosition: 0
        };
    },
    computed: {
        word() {
            return `<span class="emphasis">${this.capitalize(this.getThesaurusHeadword)}</span>`;
        },
        ...mapGetters("ThesaurusFilter", [
            "getCopiedSynonym",
            "getFirst10Synonyms",
            "getOriginalThesaurusLength",
            "getSynonymStudies",
            "getThesaurus",
            "getThesaurusHeadword",
            "isCopyToastVisible",
            "isMobileFilterPanelOpened",
            "isThesaurusLoaded"
        ]),
        ...mapGetters("Login", ["getUserActions"]),
        copied() {
            if (document.getElementById("YD_Thesaurus_728")) {
                this.bottomToastPosition = document.getElementById("YD_Thesaurus_728").offsetHeight;
            }
            return this.isCopyToastVisible && this.getCopiedSynonym.relationId && isSmallDevice();
        }
    },
    methods: {
        loadThesaurus() {
            this.$store.dispatch("ThesaurusFilter/loadThesaurus", {
                slug: this.$route.params.slug,
                component: this
            });
        },
        getMobileAd(rowIndex) {
            const index = this.showMobileAdsInRows.indexOf(rowIndex);
            return index >= 0 ? this.mobileReuseAds[index] : "";
        },
        getMobileAdPlacement(rowIndex) {
          const indices = {};
          this.showMobileAdsInRows.map((row, index) => {
            indices[row] = index + 1;
          });
          return `mob_in_content_${indices[rowIndex]}`;
        },
        displayMobileAdAtIndex(rowIndex) {
            let countThesaurus = this.getThesaurus.length;

            if (countThesaurus == 1) {
                this.showMobileAdsInRows[0] = 0;
            } else if (countThesaurus == 2) {
                this.showMobileAdsInRows[0] = 1;
            } else if (countThesaurus > 3 && countThesaurus < 12) {
                this.showMobileAdsInRows[1] = countThesaurus - 1;
            } else {
                this.showMobileAdsInRows[0] = 2;
                this.showMobileAdsInRows[1] = 11;
            }
            return this.showMobileAdsInRows.includes(rowIndex) && isSmallDevice();
        },
        capitalize,
        // Toast animation
        beforeEnterCopyToast(el) {
            el.style.opacity = 0;
        },
        enterCopyToast(el, done) {
            Velocity(el, { opacity: "1" }, { duration: 250 }, { complete: done });
        },
        leaveCopyToast(el, done) {
            Velocity(el, { opacity: "0" }, { duration: 150 }, { complete: done });
        }
    },
    mounted() {
        this.loadThesaurus();
    },
    beforeRouteUpdate(to, from, next) {
        next();
        this.loadThesaurus();
    },
    metaInfo() {
        const word = this.getThesaurusHeadword;
        return {
            title: this.$t(`thesaurusDetailPageTitle`, {
                capWord: `${capitalize(word)}`,
                word: `${word}`,
                number_of_items: `${this.getOriginalThesaurusLength}`
            }),
            meta: [
                {
                    name: "description",
                    content: this.$t(`thesaurusDetailPageMetaDescription`, {
                        word: `${word}`,
                        number_of_items: `${this.getOriginalThesaurusLength}`,
                        first_10_items: `${this.getFirst10Synonyms.join(", ")}`
                    })
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: `https://thesaurus.yourdictionary.com/${this.$route.params.slug}`
                }
            ]
        };
    },
    created() {
        if (typeof window.__PRERENDER_INJECTED === "undefined") {
            ("trigger", "test");
        }
    }
};



// WEBPACK FOOTER //
// ./src/pages/Synonyms/Detail/SynonymDetail.js